// https://davidwalsh.name/javascript-debounce-function
// https://codeburst.io/throttling-and-debouncing-in-javascript-b01cad5c8edf

export default function readTime() {
  var article = document.querySelector(".article");
  if(article) {
    const text = article.innerText;
    const wpm = 225;
    const words = text.trim().split(/\s+/).length;
    const time = Math.ceil(words / wpm);

    let timeElem = document.querySelector(".time");
    if (timeElem) {
      timeElem.innerText = time;
    }
  }

}
